import React, { useState, useEffect } from "react";
import "./style.scss";
import SelectPhotoModal from "./UpdatePhotoModal";
import { getFileUrl } from "./common";
import { ReactComponent as NoBatchWarning } from "assets/img/svg/NoBatchWarning.svg";
import CustomTooltip from "views/pages/manage/common/customTooltip/CustomTooltip";
const StudentPhoto = ({
  photoKey,
  fetchApplications,
  psid,
  isUpdate = true,
}) => {
  const [open, setOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const isPhotoKeyExist =
    photoKey === "Absent" || photoKey === null ? false : true;

  useEffect(() => {
    if (isPhotoKeyExist) getImgSrc();
  }, [photoKey, isPhotoKeyExist]);

  const getImgSrc = async () => {
    const imgSrc = await getFileUrl(photoKey);
    setImageSrc(imgSrc);
  };

  return (
    <div className="photo-container ">
      {open && (
        <SelectPhotoModal
          open={open}
          setOpen={setOpen}
          fetchApplications={fetchApplications}
          psid={psid}
        />
      )}
      {imageSrc ? (
        <img height={"96px"} width={"96px"} src={imageSrc}></img>
      ) : (
        <div className="camera-icon">
          <i className="fas fa-camera"></i>
        </div>
      )}
      {isUpdate && (
        <div onClick={() => setOpen(true)} className=" update-photo-btn ">
          {isPhotoKeyExist ? "Update " : "Upload"}
        </div>
      )}
    </div>
  );
};
export const StudentPhotoOnIdCard = ({
  photoKey,
  fetchApplications,
  psid,
  isUpdate = true,
}) => {
  const [open, setOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const isPhotoKeyExist =
    photoKey === "Absent" || photoKey === null || photoKey === undefined
      ? false
      : true;

  useEffect(() => {
    if (isPhotoKeyExist) getImgSrc();
  }, [photoKey, isPhotoKeyExist]);

  const getImgSrc = async () => {
    const imgSrc = await getFileUrl(photoKey);
    setImageSrc(imgSrc);
  };

  return (
    <div className="" style={{ cursor: "pointer" }}>
      {open && (
        <SelectPhotoModal
          open={open}
          setOpen={setOpen}
          fetchApplications={fetchApplications}
          psid={psid}
        />
      )}

      {isUpdate && (
        <div className=" update-photo-btn ">
          {!isPhotoKeyExist && (
            <CustomTooltip
              title={
                "Click to upload a photo and generate the student's ID card"
              }
              openHandler = {()=>setOpen(true)}
            >
              <div onClick={() => setOpen(true)} >
                <NoBatchWarning height={24} width={24} />
              </div>
            </CustomTooltip>
          )}
        </div>
      )}
    </div>
  );
};

export default StudentPhoto;
